/**
 * @file GlobalHeader/utils.js
 * @copyright 2017 CBC/Radio-Canada. All rights reserved.
 */
import { TERTIARY_NAV_LIST } from "../../constants";

/**
 * Check the constants to see if the given path has a third-level navigation, e.g. /sports/hockey/nhl/
 * @param {Object} path The url path of the given page
 * @returns {object} The list of third-level navigation items
 */
export const getTertiaryNavList = (path) => {
    // Check if the direct path corresponds to an item in TERTIARY_NAV_LIST
    // for example /meta/global/header/sports/hockey/nhl
    if (TERTIARY_NAV_LIST && TERTIARY_NAV_LIST[path]) {
        return [...TERTIARY_NAV_LIST[path]];
    }

    // Otherwise, try checking if it's somehow nested within one of the values
    // for example /meta/global/header/sports/hockey/nhl/scores
    for (let pathInList in TERTIARY_NAV_LIST) {
        if (
            Object.prototype.hasOwnProperty.call(
                TERTIARY_NAV_LIST,
                pathInList
            ) &&
            path.startsWith(pathInList)
        ) {
            return [...TERTIARY_NAV_LIST[pathInList]];
        }
    }
    return null;
};
